import { useQuery } from '@tanstack/react-query';
import { useInternalApiRequest } from 'shared/hooks';
import { getQueryKeyForInternal } from 'state/utils/getQueryKeyForInternal';
import { useStoreValue } from 'state/hooks/useStore';
import { useSessionValue } from 'appLayer/auth';

import { SUBSCRIPTION_API_URL } from '@portal/config/base';
import type { OrdersResponseV2 } from './types';
import { requestErrors } from '../constants';

export const getQueryKeyForGetOrdersV2 = (store: string) =>
  getQueryKeyForInternal({
    keys: ['orders-v2', store]
  });

export const useQueryGetOrdersV2 = () => {
  const request = useInternalApiRequest();
  const store = useStoreValue();
  const session = useSessionValue();

  const data = useQuery({
    enabled: Boolean(session?.accessToken),
    queryFn: async () => {
      const apiUrl = SUBSCRIPTION_API_URL[store];
      if (!apiUrl) throw new Error(requestErrors.API_URL_NOT_DEFINED);

      const ordersData = await request<OrdersResponseV2>({
        method: 'GET',
        url: `${apiUrl}/user/order`,
        shouldTimeout: true
      });

      if (!ordersData) throw new Error(requestErrors.ORDERS_DATA_NOT_FOUND);

      return ordersData;
    },
    queryKey: getQueryKeyForGetOrdersV2(store),
    retry: 3,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true
  });

  return {
    ...data,
    isError: data.isError && !(data.failureCount === 0)
  };
};
